<template>
  <div class="view-document" v-if="document">
      <label @click="$router.go(-1)" class="back">
        <figure>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </figure>
        <p>Voltar</p>
      </label>
      <div class="infos" v-if="document">
        <div class="interactions">
          <div class="stats" :class="{'reopen': abilities.reopenDocument, 'close': isDocumentOpenValue && abilities.completeDocument, 'block': !(isDocumentOpenValue && abilities.completeDocument && abilities.reopenDocument && !abilities.transferDocument)}">
            <div class="tag">{{ document.number }}</div>
            <!-- TAGS CLASSES processing, concluded, late, extended, pending, exceptions -->
            <div class="tag processing" :class="document.status">{{ documentStatusTranslations[document.status] }}</div>
            <div v-if="document.is_exception" class="tag exceptions">Exceções</div>
          </div>
          <h1>Documento</h1>
          <h2 class="subtitle">{{ document.title }}</h2>
          <div class="ai-summary-trigger" v-if="hasAiModule">
            <button type="button" class="ai-toggle-button" :disabled="isSummarizingDocument" @click="summarizeDocument">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
                <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
              </svg>
              {{ isSummarizingDocument ? 'Resumindo...' : 'Resumir com IA' }}
            </button>
            <div class="ai-summary" v-if="documentSummary">
              <p>{{ documentSummary }}</p>
              <button type="button" class="ai-summary__close" @click="documentSummary = ''">Fechar</button>
            </div>
          </div>
          <div class="document" v-for="interaction in document.interactions">
            <h4 class="interaction-creator">{{ interaction.creator.name }}</h4>
            <div class="document__item">
                <div v-html="interaction.content"></div>
            </div>
            <div v-if="interaction.files.length" class="document__attachments">
              <h1>DOCUMENTOS EM ANEXO</h1>
              <div v-for="file in interaction.files">
                <p>{{ file.name }}</p>
                <div>
                  <button v-if="file.mime_type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" @click="visualizeFile(file)" class="tooltip">
                    <figure>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15.5819 11.9999C15.5819 13.9799 13.9819 15.5799 12.0019 15.5799C10.0219 15.5799 8.42188 13.9799 8.42188 11.9999C8.42188 10.0199 10.0219 8.41992 12.0019 8.41992C13.9819 8.41992 15.5819 10.0199 15.5819 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </figure>
                  </button>
                  <a href="#" @click="downloadFile($event, file)">
                    <button class="tooltip">
                      <figure>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <g clip-path="url(#clip0_519_4148)">
                            <path d="M7.5 9.1665V14.1665L9.16667 12.4998"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.50065 14.1667L5.83398 12.5"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.3327 8.33317V12.4998C18.3327 16.6665 16.666 18.3332 12.4993 18.3332H7.49935C3.33268 18.3332 1.66602 16.6665 1.66602 12.4998V7.49984C1.66602 3.33317 3.33268 1.6665 7.49935 1.6665H11.666"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.3327 8.33317H14.9993C12.4993 8.33317 11.666 7.49984 11.666 4.99984V1.6665L18.3327 8.33317Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_519_4148">
                              <rect width="20" height="20" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </figure>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-reply" v-if="hasAiModule && isDocumentOpenValue">
            <button type="button" class="ai-toggle-button" @click="isAiReplyPanelOpen = !isAiReplyPanelOpen">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
                <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
              </svg>
              Sugerir resposta com IA
            </button>
            <div class="ai-panel" v-if="isAiReplyPanelOpen">
              <label for="ai-reply-prompt">Instrução para a IA (opcional)</label>
              <textarea id="ai-reply-prompt" v-model="aiReplyPrompt" rows="2" placeholder="Ex: Informe que o prazo foi atendido e solicite o próximo passo."></textarea>
              <div class="ai-panel__footer">
                <span class="ai-panel__quota" v-if="aiUsage">{{ aiUsage.remaining }} de {{ aiUsage.limit }} gerações restantes hoje</span>
                <input v-if="!isSuggestingAiReply" type="button" value="Gerar sugestão" :disabled="!!aiUsage && aiUsage.remaining <= 0" @click="suggestAiReply">
                <SpinnerLoaderButton v-else :height="40" :maxWidth="160" />
              </div>
            </div>
          </div>
          <TextEditor v-if="isDocumentOpenValue" :value="updatePayload.content" :setValue="(value) => updatePayload.content = value" />
          <div class="ai-compliance" v-if="hasAiModule && isDocumentOpenValue">
            <button type="button" class="ai-toggle-button" :disabled="!updatePayload.content || isReviewingCompliance" @click="reviewCompliance">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
                <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
              </svg>
              {{ isReviewingCompliance ? 'Revisando...' : 'Revisar formalidades com IA' }}
            </button>
            <div class="ai-compliance__result" v-if="complianceResult">
              <p class="ai-compliance__ok" v-if="complianceResult.ok">Nenhuma formalidade pendente encontrada.</p>
              <ul class="ai-compliance__issues" v-else>
                <li v-for="(issue, index) in complianceResult.issues" :key="index">{{ issue }}</li>
              </ul>
            </div>
          </div>
          <h1 v-if="keywords.length">Palavras chaves</h1>
          <h2 v-if="keywords.length">Separe por vírgula, exemplo: férias, pagamento.</h2>
          <MyTags v-if="keywords.length" :value="keywords" :name="'keywords'" :placeholder="'Digite a palavra chave'" :disabled="true" />
          <h1 v-if="isDocumentOpenValue">Arquivo do documento</h1>
          <h2 v-if="isDocumentOpenValue">Adicione um arquivo a esse documento, podendo ser DOC ou PDF.</h2>
          <FileUploader v-if="isDocumentOpenValue" :files="updatePayload.files!" :pushFile="(file) => updatePayload.files!.push(file)" />
          <h1 v-if="mentions.length">Citado(s) no(s) documento(s)</h1>
          <h2 v-if="mentions.length">Escreva nome e sobrenome dos participantes citados no(s) anexo(s) e separe por vírgula.</h2>
          <MyTags v-if="mentions.length" :value="mentions" :name="'mentions'" :placeholder="'Digite nome e sobrenome'" :disabled="true" />
          <h1 v-if="isDocumentOpenValue">{{ isChamber ? 'Câmaras' : 'Setores' }} <strong>(obrigatório)</strong></h1>
          <h2 v-if="isDocumentOpenValue">Quais {{ isChamber ? 'câmaras' : 'setores' }} agora precisam ter acesso a esse documento? Você pode selecionar mais de um.</h2>
          <MyOptions v-if="isDocumentOpenValue" :currentValue="updatePayload.organizations?.length ? `${updatePayload.organizations.length} ${isChamber ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'">
            <div class="item" v-for="(organization, index) in organizations" :key="index">
              <input
                type="checkbox"
                :id="'organizations-' + index"
                :value="organization.id"
                :checked="updatePayload.organizations?.some((o) => o.id === organization.id)"
                @change="toggleUpdateOrganization(organization, ($event.target as HTMLInputElement).checked)"
              >
              <label :for="'organizations-' + index">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                    <g clip-path="url(#clip0_388_3128)">
                      <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_388_3128">
                        <rect width="12.5" height="10" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p>{{organization.name}}</p>
              </label>
            </div>
          </MyOptions>
          <h1 v-if="isDocumentOpenValue">Responsáveis <strong>(obrigatório)</strong></h1>
          <h2 v-if="isDocumentOpenValue">Quem agora precisa ter acesso a esse documento? Você pode selecionar mais de uma pessoa.</h2>
          <MyOptions v-if="isDocumentOpenValue" :currentValue="updatePayload.responsibles?.length ? `${updatePayload.responsibles.length} responsável(is) selecionado(s)` : 'Selecione'">
            <div class="item" v-for="(responsible, index) in usersToTransfer" :key="index">
              <input
                type="checkbox"
                :id="'responsible-' + index"
                :value="responsible.id"
                :checked="updatePayload.responsibles?.some((r) => r.id === responsible.id)"
                @change="toggleUpdateResponsible(responsible, ($event.target as HTMLInputElement).checked)"
              >
              <label :for="'responsible-' + index">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                    <g clip-path="url(#clip0_388_3128)">
                      <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_388_3128">
                        <rect width="12.5" height="10" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p>{{ responsible.name }} {{ responsible.last_name }}</p>
              </label>
            </div>
          </MyOptions>
          <h1 v-if="abilities.extendDocument">Data limite <strong>(obrigatório)</strong></h1>
          <h2 v-if="abilities.extendDocument">Prazo máximo para o documento ser apreciado</h2>
          <label v-if="abilities.extendDocument" class="date-picker-label" for="date-limit-document" @click="isDatePickerModalOpen = true;">
          <!-- :value="limitDate.replaceAll('-', '/')" -->
            <input type="text" placeholder="Selecione uma data" name="date-limit-document" id="date-limit-document" :value="updatePayload.limit_date ? formatDate(updatePayload.limit_date) : formatDate(document.limit_date.slice(0, 10))" readonly>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M8 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.5 9.08984H20.5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.6937 13.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.6937 16.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.9945 13.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.9945 16.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.29529 13.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.29529 16.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </label>
          <MyModal v-if="abilities.extendDocument" :width="'341px !important'" :height="'517px !important'" :className="'date-limit'" :isOpen="isDatePickerModalOpen" :toggleModal="(v: boolean) => isDatePickerModalOpen = v" :zIndex="100">
            <div class="modal-date-title">
              <h1>Data limite</h1>
              <h2>Prazo máximo para ser aceito.</h2>
            </div>
            <MyDatePicker :min="{ day: new Date(document.limit_date).getDate(), month: new Date(document.limit_date).getMonth() + 1, year: new Date(document.limit_date).getFullYear() }" :name="'limit_date'" :setValue="(date) => limitDateValue = date"/>
            <input type="button" value="Aplicar data" @click="updatePayload.limit_date = limitDateValue; isDatePickerModalOpen = false">
          </MyModal>
          <MyModal v-if="isDocumentOpenValue && abilities.transferDocument" :width="'776px'" :height="'1171px'" :isOpen="isTransferDocumentModalOpen" :class-name="'transfer-document'" :toggleModal="(v: boolean) => isTransferDocumentModalOpen = v" :zIndex="100">
            <div class="transfer">
              <h1>Transferir documento</h1>
              <h1>{{ isChamber ? 'Câmaras' : 'Setores' }} <strong>(obrigatório)</strong></h1>
              <h2>Quais {{ isChamber ? 'câmaras' : 'setores' }} agora precisam ter acesso a esse documento? Você pode selecionar mais de um.</h2>
              <MyOptions :currentValue="updatePayload.organizations?.length ? `${updatePayload.organizations.length} ${isChamber ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'">
                <div class="item" v-for="(organization, index) in organizations" :key="index">
                  <input
                    type="checkbox"
                    :id="'organizations-transfer-modal-' + index"
                    :value="organization.id"
                    :checked="updatePayload.organizations?.some((o) => o.id === organization.id)"
                    @change="toggleUpdateOrganization(organization, ($event.target as HTMLInputElement).checked)"
                  >
                  <label :for="'organizations-transfer-modal-' + index">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                        <g clip-path="url(#clip0_388_3128)">
                          <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_388_3128">
                            <rect width="12.5" height="10" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <p>{{organization.name}}</p>
                  </label>
                </div>
              </MyOptions>
              <h1>Responsáveis <strong>(obrigatório)</strong></h1>
              <h2>Quem agora precisa ter acesso a esse documento? Você pode selecionar mais de uma pessoa.</h2>
              <MyOptions :currentValue="updatePayload.responsibles?.length ? `${updatePayload.responsibles.length} responsável(is) selecionado(s)` : 'Selecione'">
                <div class="item" v-for="(responsible, index) in usersToTransfer" :key="index">
                  <input
                    type="checkbox"
                    :id="'responsible-transfer-modal-' + index"
                    :value="responsible.id"
                    :checked="updatePayload.responsibles?.some((r) => r.id === responsible.id)"
                    @change="toggleUpdateResponsible(responsible, ($event.target as HTMLInputElement).checked)"
                  >
                  <label :for="'responsible-transfer-modal-' + index">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                        <g clip-path="url(#clip0_388_3128)">
                          <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_388_3128">
                            <rect width="12.5" height="10" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <p>{{ responsible.name }} {{ responsible.last_name }}</p>
                  </label>
                </div>
              </MyOptions>
              <h1>Conteúdo desse documento <strong>(obrigatório)</strong></h1>
              <h2>Descreva os principais detalhes que irão ajudar aos interessados saber sobre o documento.</h2>
              <TextEditor :setValue="(value) => updatePayload.content = value" />
              <h1>Arquivo do documento</h1>
              <h2>Adicione um arquivo a esse documento, podendo ser DOC ou PDF.</h2>
              <FileUploader :files="updatePayload.files!" :pushFile="(file) => updatePayload.files!.push(file)" />
            </div>
            <nav>
              <input :disabled="!hasChanges" type="button" value="Enviar" @click="updateDocument()" v-if="!isUpdatingDocument">
              <SpinnerLoaderButton v-else :height="60" :maxWidth="464"/>
              <input type="button" value="Cancelar" @click="isTransferDocumentModalOpen = false;">
            </nav>
          </MyModal>
          <section v-if="isDocumentOpenValue" class="actions-doc">
            <nav>
              <input v-if="!isUpdatingDocument" type="button" value="Enviar" @click="updateDocument()" :disabled="!hasChanges">
              <SpinnerLoaderButton v-else :height="60" :maxWidth="464"/>
              <input type="button" value="Cancelar" @click="$router.go(-1)">
            </nav>
          </section>
          <section v-else-if="abilities.reopenDocument" @click="isConfirmCompleteDocumentModal = true" class="actions-doc reopen">
            <nav>
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill='none' d="M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill='none' d="M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill='none' d="M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Reabrir
              </button>
            </nav>
          </section>
        </div>
        <div class="historics" :data-doc-number="document.number">
          <div class="actions">
            <button v-if="isDocumentOpenValue && abilities.completeDocument" @click="openConclusionNoteModal()">
              <svg v-if="!isDocumentOpenValue" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill='none' d="M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
                <g clip-path="url(#clip0_519_4047)">
                  <path stroke='none' d="M3.87391 8.53798C3.77705 8.63467 3.64578 8.68897 3.50891 8.68897C3.37205 8.68897 3.24078 8.63467 3.14391 8.53798L0.227247 5.62132C0.155209 5.54941 0.0980586 5.464 0.0590649 5.36999C0.0200711 5.27597 0 5.17518 0 5.0734C0 4.97162 0.0200711 4.87083 0.0590649 4.77681C0.0980586 4.68279 0.155209 4.59739 0.227247 4.52548L0.592247 4.16132C0.73758 4.01603 0.934665 3.93441 1.14016 3.93441C1.34566 3.93441 1.54275 4.01603 1.68808 4.16132L3.50891 5.98048L8.42558 1.06382C8.57091 0.91853 8.768 0.836914 8.9735 0.836914C9.17899 0.836914 9.37608 0.91853 9.52141 1.06382L9.88641 1.42882C9.95845 1.50072 10.0156 1.58613 10.0546 1.68015C10.0936 1.77416 10.1137 1.87495 10.1137 1.97673C10.1137 2.07852 10.0936 2.1793 10.0546 2.27332C10.0156 2.36734 9.95845 2.45274 9.88641 2.52465L3.87391 8.53798Z" />
                </g>
                <defs>
                  <clipPath id="clip0_519_4047">
                    <rect width="10.1175" height="7.85583" fill="white" transform="translate(0 0.833496)"/>
                  </clipPath>
                </defs>
              </svg>
              Concluir
            </button>
            <button v-else-if="abilities.reopenDocument" @click="isConfirmCompleteDocumentModal = true" id="reopen">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill='none' d="M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Reabrir
            </button>
            <button :disabled="!abilities.transferDocument" @click="isTransferDocumentModalOpen = true" v-if="isDocumentOpenValue">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill='none' d="M8.33268 4.99984H11.666C13.3327 4.99984 13.3327 4.1665 13.3327 3.33317C13.3327 1.6665 12.4993 1.6665 11.666 1.6665H8.33268C7.49935 1.6665 6.66602 1.6665 6.66602 3.33317C6.66602 4.99984 7.49935 4.99984 8.33268 4.99984Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M11.6667 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M13.334 3.3501C16.109 3.5001 17.5007 4.5251 17.5007 8.33343V12.5001" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M17.5 15.8335V18.3335H15" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill='none' d="M12.5 13.3335L17.4667 18.3002" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Transferir
            </button>
            <button v-if="document.current_protocol" @click="isProtocolModalOpen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" fill="none" d="M0 0h24v24H0z" />
                <path fill="none" d="M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3" />
                <path fill="none" d="M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6" />
                <path fill="none" d="M12 11v2a14 14 0 0 0 2.5 8" />
                <path fill="none" d="M8 15a18 18 0 0 0 1.8 6" />
                <path fill="none" d="M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95" />
              </svg>
              Ver Protocolo
            </button>
            <button v-if="document.protocols?.length" @click="isProtocolsListModalOpen = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path fill="none" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline fill="none" points="14 2 14 8 20 8"></polyline>
                <line fill="none" x1="16" y1="13" x2="8" y2="13"></line>
                <line fill="none" x1="16" y1="17" x2="8" y2="17"></line>
                <polyline fill="none" points="10 9 9 9 8 9"></polyline>
              </svg>
              Protocolos
            </button>
          </div>
          <h1>Informações</h1>
          <div class="info">
            <p v-if="document.creator?.organization">{{ isChamber ? 'Câmara' : 'Setor' }} inicial: <strong>{{ document.creator?.organization?.acronym ? document.creator?.organization.acronym : document.creator?.organization?.name }}</strong></p>
            <p>Assunto: <strong>{{ document.subject.name }}</strong></p>
            <p>Criado por: <strong>{{ document.creator?.name }}</strong></p>
            <p v-if="document.responsibles && document.responsibles.length">Responsável: <strong>{{ document.responsibles[0].name }}</strong><strong v-if="document.responsibles[0].last_name">{{ document.responsibles[0].last_name }}</strong></p>
            <div>
              <p>Criado em: <strong>{{ new Date(document.created_at).toLocaleDateString() }}</strong></p>
              <p>Data limite: <strong>{{ new Date(document.limit_date).toLocaleDateString() }}</strong></p>
            </div>
          </div>
          <div class="historic-title-actions">
            <h1>Histórico</h1>
            <button class="print-btn-icon tooltip" @click="printHistory">
              <figure>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9V2h12v7"></path>
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                  <rect x="6" y="14" width="12" height="8" fill="none"></rect>
                </svg>
              </figure>
            </button>
          </div>
          <div class="print-header">
            <h1>Relatório de Histórico</h1>
            <h2>Documento: {{ document.number }}</h2>
            <h3>Título: {{ document.title }}</h3>
          </div>
          <div class="historic">
            <div class="item" v-for="(log, index) in document.logs.filter(log => log.action !== DocumentLogActionEnum.VIEW)">
              <span>{{ index + 1 }}</span>
              <p>{{ log.creator.name }}: <strong>{{ documentLogActionTranslations[log.action] }}</strong></p>
              <p>Log criado em: <strong>{{ new Date(log.created_at).toLocaleDateString() }} ás {{ new Date(log.created_at).toLocaleTimeString().slice(0, 5) }}</strong></p>
              <p v-if="log.limit_date">Vencimento: <strong>{{ new Date(log.limit_date).toLocaleDateString() }}</strong></p>
              <div>
                <p v-if="log.responsibles.length">
                  <strong>{{ log.creator.name }}</strong> enviou o documento <strong>{{ document.number }}</strong> para
                  <template v-for="(responsible, rIndex) in log.responsibles" :key="responsible.id">
                    <strong>{{ responsible.name }}</strong> da(o) {{ responsible.organization?.name }}<template v-if="rIndex < log.responsibles.length - 1">, </template>
                  </template>.
                </p>
                <p v-else-if="log.action == 'extension'"><strong>{{ log.creator.name }}</strong> prorrogou a data limite do documento para <strong>{{ new Date(log.limit_date).toLocaleDateString('pt-BR') }}</strong></p>
                <p v-else-if="log.action == 'completion'"><strong>{{ log.creator.name }}</strong> finalizou o documento <strong>{{ document.number }}</strong></p>
                <p v-else-if="log.action == 'reopening'"><strong>{{ log.creator.name }}</strong> reabriu o documento <strong>{{ document.number }}</strong></p>
              </div>
            </div>
          </div>
          <div class="document-notes" v-if="document.notes && document.notes.length">
            <div class="document-notes__header">
              <h1>Notas</h1>
              <span class="document-notes__badge">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <path d="M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Visível apenas para você
              </span>
            </div>
            <div class="document-notes__list">
              <div class="document-notes__item" v-for="note in document.notes" :key="note.id">
                <div class="document-notes__item-header">
                  <p class="document-notes__title">{{ note.title }}</p>
                  <span class="document-notes__date">{{ formatDate(note.event_date) }}</span>
                </div>
                <p v-if="note.description" class="document-notes__description" v-html="note.description"></p>
              </div>
            </div>
          </div>

          <h1 v-if="documentViews.length">Vizualizações</h1>
          <div class="viewers" v-if="documentViews.length">
            <div class="viewer" v-for="view in documentViews">
              <p>{{ view.creator.name }}<span v-if="view.creator.last_name"> {{ view.creator.last_name }}</span>: <strong>Visualizou o comunicado</strong></p>
              <p>Log criado em: <strong>{{ new Date(view.created_at).toLocaleDateString() }} ás {{ new Date(view.created_at).toLocaleTimeString().slice(0, 5) }}</strong></p>
            </div>
          </div>
        </div>
      </div>

      <MyModal v-if="abilities.completeDocument || abilities.reopenDocument" :width="!isDocumentOpenValue ? '330px !important' : '330px !important'" :height="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime() ? '517px !important' : '299px !important'" :isOpen="isConfirmCompleteDocumentModal" :class-name="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime() ? 'confirm-complete-document picker' : 'confirm-complete-document'" :toggleModal="(v: boolean) => isConfirmCompleteDocumentModal = v" :zIndex="100">
        <div>
          <svg v-if='isDocumentOpenValue || !(!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime())' :style="!(!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime()) && !isDocumentOpenValue ? 'margin: 0 auto;' : ''" xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
            <path d="M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831" fill="#0071CF"/>
            <path d="M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831" fill="#0071CF"/>
            <path d="M47.6673 23.9847V33.2363C47.6673 33.9297 46.5623 34.233 46.0856 33.7347C45.0673 32.673 43.789 31.8713 42.3157 31.4163C38.914 30.3547 34.9923 31.3947 32.5223 33.9513C30.9623 35.6197 30.1173 37.6997 30.074 39.953C30.074 40.343 29.879 40.6897 29.5756 40.928C28.0156 42.163 27.0623 44.0913 27.0623 46.3013V46.323C27.0623 47.0163 26.564 47.6447 25.8706 47.6447H15.904C9.53398 47.6663 4.33398 42.4663 4.33398 36.0747V13.9097C4.33398 8.62301 8.62398 4.33301 13.9107 4.33301H18.9373C22.469 4.33301 23.574 5.48134 24.9823 7.36634L28.0156 11.3963C28.6873 12.2847 28.774 12.393 30.0306 12.393H36.0756C41.2323 12.393 45.609 15.773 47.104 20.453C47.429 21.428 47.6023 22.4247 47.6456 23.4863C47.6673 23.638 47.6673 23.833 47.6673 23.9847Z" fill="#0071CF"/>
          </svg>
          <h1 :style="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime() ? 'justify-content: space-between;' : 'justify-content: center;'">
            {{ !isDocumentOpenValue ? 'Reabrir' : 'Concluir'}} processo
            <figure @click="isConfirmCompleteDocumentModal = false" v-if="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clip-path="url(#clip0_198_1747)">
                  <path d="M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_198_1747">
                  <rect width="15.794" height="15.793" fill="white"/>
                  </clipPath>
                  </defs>
              </svg>
            </figure>
          </h1>
          <h2 :style="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime()? 'text-align: start;' : ''">Quer mesmo {{ !isDocumentOpenValue ? 'reabrir' : 'concluir'}} esse processo? <br>
            {{ isDocumentOpenValue ? 'Após conclusão só será possível novas interações se o documento for reaberto.' : '' }}  {{!(!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime()) && !isDocumentOpenValue ? 'Após conclusão já será possível ser feita novas interações.' : '' }}
          </h2>
          <div v-if="!isDocumentOpenValue && new Date(document.limit_date).getTime() < new Date().getTime()" class="dates">
            <MyDatePicker :min="{ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() }" :setValue="(v) => updatePayload.limit_date = v" name="limit" />
          </div>
          <section>
            <button v-if="!isUpdatingDocument" @click="updateDocument(!isDocumentOpenValue ? DocumentStatusEnum.UNDER_REVIEW : DocumentStatusEnum.COMPLETED)">Sim</button>
            <SpinnerLoaderButton v-else :isButton='false' />
            <input @click="isConfirmCompleteDocumentModal = false;" type="button" value="Cancelar">
          </section>
        </div>
      </MyModal>

      <MyModal v-if="abilities.completeDocument" :width="'640px !important'" :height="'fit-content !important'" :isOpen="isConclusionNoteModalOpen" :class-name="'conclusion-note'" :toggleModal="(v: boolean) => closeConclusionNoteModal(v)" :zIndex="100">
        <div class="conclusion-note-modal">
          <header>
            <h1>Concluir documento</h1>
          </header>
          <div class="body">
            <label class="field-label">Nota de conclusão <strong>(obrigatório)</strong></label>
            <div class="editor-wrapper" :class="{ 'editor-wrapper--error': showConclusionNoteError && isConclusionNoteEmpty }">
              <TextEditor v-if="isConclusionNoteModalOpen" :key="conclusionNoteEditorKey" :value="conclusionNote" :setValue="(value) => conclusionNote = value" />
            </div>
            <p v-if="showConclusionNoteError && isConclusionNoteEmpty" class="error-text">A nota de conclusão é obrigatória.</p>
          </div>
          <nav>
            <button type="button" class="submit" :disabled="isConclusionNoteEmpty" @click="confirmConclusionNote()">concluir documento</button>
            <button type="button" class="cancel" @click="closeConclusionNoteModal(false)">cancelar</button>
          </nav>
        </div>
      </MyModal>

      <MyModal :isOpen="isFileVisualizerOpen" :class="'docView'" :toggleModal="(v: boolean) => isFileVisualizerOpen = v" :width="'80rem'" :height="'50rem'" :zIndex='10'>
        <iframe v-if="fileVisualizerSrc" :src="fileVisualizerSrc" width="100%" height="100%"></iframe>
        <SpinnerLoader v-else />
      </MyModal>

      <MyModal v-if="document?.current_protocol" :isOpen="isProtocolModalOpen" :class-name="'digital-protocol'" :toggleModal="(v: boolean) => isProtocolModalOpen = v" :zIndex="100" :width="'440px'" :height="'630px'">
        <div class="protocol-content" id="printable-protocol">
          <div class="icon-fingerprint">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#090909" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3" />
              <path d="M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6" />
              <path d="M12 11v2a14 14 0 0 0 2.5 8" />
              <path d="M8 15a18 18 0 0 0 1.8 6" />
              <path d="M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95" />
            </svg>
          </div>
          <h1>Protocolo digital</h1>
          
          <div class="row info-row">
            <div class="col">
              <span class="label">REFERENTE</span>
              <span class="value">Documento<br><strong>{{ document.number }}</strong></span>
            </div>
            <div class="col">
              <span class="label">&nbsp;</span>
              <span class="value">Ofício/portaria<br><strong>{{ document.physical_document_number || '-' }}</strong></span>
            </div>
          </div>
          <div class="divider"></div>
          
          <div class="row info-row">
            <div class="col">
              <span class="label">VISUALIZADO EM</span>
              <span class="value">Data<br><strong>{{ formatBrazilDate(document.current_protocol.created_at) }}</strong></span>
            </div>
            <div class="col">
              <span class="label">&nbsp;</span>
              <span class="value">Horas<br><strong>{{ formatBrazilTime(document.current_protocol.created_at) }}</strong></span>
            </div>
          </div>
          <div class="divider"></div>
          
          <div class="row full info-row">
            <span class="label">USUÁRIO QUE VISUALIZOU</span>
            <span class="value"><strong>{{ document.current_protocol.creator?.name }} {{ document.current_protocol.creator?.last_name || '' }}</strong></span>
          </div>
          <div class="divider"></div>
          
          <div class="row full protocol-number info-row">
            <span class="label">NÚMERO DO PROTOCOLO GERADO</span>
            <span class="value number"><strong>{{ String(document.current_protocol.number).padStart(3, '0') }}{{ document.current_protocol.organization?.acronym ? ' - ' + document.current_protocol.organization.acronym : '' }}</strong></span>
          </div>
          
          <div class="actions">
            <button class="btn-save" @click="downloadProtocolFile">
              salvar 
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2-2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
            </button>
            <button class="btn-print" @click="printProtocolFile">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
              imprimir
            </button>
          </div>
        </div>
        <div class="footer-alert">
          O SETOR DE ORIGEM FOI NOTIFICADO QUE VOCÊ JÁ VISUALIZOU<br>ESSE DOCUMENTO E RECEBEU O PROTOCOLO GERADO.
        </div>
      </MyModal>

      <MyModal v-if="document?.protocols?.length" :isOpen="isProtocolsListModalOpen" :class-name="'protocols-list'" :toggleModal="(v: boolean) => isProtocolsListModalOpen = v" :zIndex="100" :width="'650px'" :height="'fit-content'">
        <div class="protocols-list-content">
          <div class="modal-header-info">
            <div class="header-top">
              <h2>Protocolos Gerados</h2>
              <button class="btn-print-all" @click="printAllProtocols">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
                Imprimir/Baixar
              </button>
            </div>
            <div class="doc-reference">
              <span class="ref-label">REFERENTE AO:</span>
              <span class="ref-value">Documento <strong>{{ document.number }}</strong> • Ofício/portaria <strong>{{ document.physical_document_number || '-' }}</strong></span>
            </div>
          </div>
          <p class="subtitle">Acompanhe quais organizações já visualizaram e geraram protocolo para este documento.</p>
          
          <div class="protocols-grid">
            <div class="protocol-card" v-for="protocol in document.protocols" :key="protocol.id">
              <div class="card-header">
                <span class="org-name">{{ protocol.organization?.name }} ({{ protocol.organization?.acronym }})</span>
                <div class="header-right">
                  <span class="protocol-badge">{{ String(protocol.number).padStart(3, '0') }}{{ protocol.organization?.acronym ? ' - ' + protocol.organization.acronym : '' }}</span>
                  <div class="card-actions">
                    <button class="btn-action" title="Salvar" @click="downloadProtocolFile(protocol)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2-2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                    </button>
                    <button class="btn-action" title="Imprimir" @click="printProtocolFile(protocol)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="info-item">
                  <span class="info-label">Visualizado por</span>
                  <span class="info-value">{{ protocol.creator?.name }} {{ protocol.creator?.last_name || '' }}</span>
                </div>
                <div class="info-item" style="text-align: right;">
                  <span class="info-label">Data e Hora</span>
                  <span class="info-value">{{ formatBrazilDate(protocol.created_at) }} às {{ formatBrazilTime(protocol.created_at) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MyModal>
  </div>
  <SpinnerLoader v-else />
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import TextEditor from '@/components/input/TextEditor.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { DocumentModel, DocumentFileModel } from '@/models/DocumentModel'
import DocumentLogActionEnum, { documentLogActionTranslations } from '@/enums/DocumentLogActionEnum'
import { OrganizationModel } from '@/models/OrganizationModel'
import { UserModel } from '@/models/UserModel'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import DocumentStatusEnum, { documentStatusTranslations } from '@/enums/DocumentStatusEnum'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { user, hasAiModule } from '@/global/states/GlobalState'
import { toast } from 'vue3-toastify'
import MyTags from '@/components/tag/MyTags.vue'
import DocumentTagTypeEnum from '@/enums/DocumentTags/DocumentTagTypeEnum'
import useDocument from '@/hooks/documents/useDocument'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const document = ref<DocumentModel>()
const organizations = ref<OrganizationModel[]>()
const users = ref<UserModel[]>()
const limitDateValue = ref('')
const updatePayload = ref<Partial<{content?: string, limit_date?: string, files: File[], responsibles: UserModel[], organizations: OrganizationModel[]}>>({ files: [] })
const isDatePickerModalOpen = ref(false)
const props = defineProps<{ id: number }>()
const documentViews = computed(() => document.value?.logs.filter(log => log.action == DocumentLogActionEnum.VIEW) ?? [])
const isUpdatingDocument = ref(false)
const isFileVisualizerOpen = ref(false)
const fileVisualizerSrc = ref('')
const mentions = computed<string[]>(() => (document.value?.tags.filter((tag) => tag.type === DocumentTagTypeEnum.MENTION).map((tag) => tag.title)) ?? [])
const keywords = computed<string[]>(() => (document.value?.tags.filter((tag) => tag.type === DocumentTagTypeEnum.KEYWORD).map((tag) => tag.title)) ?? [])

const { getAllowedUsersToTransfer, getAbilities, isDocumentOpen } = useDocument()
const isDocumentOpenValue = computed(() => document.value ? isDocumentOpen(document.value) : false)
const abilities = computed(() => getAbilities(user.value, document.value))
const usersToTransfer = computed(() => getAllowedUsersToTransfer(user.value, document.value, users.value, updatePayload.value.organizations))

const isPayloadContentEmpty = computed(() => {
  const content = updatePayload.value.content ?? ''
  const strippedContent = content.replace(/<[^>]*>/g, '').trim()
  return strippedContent === ''
})

const currentDocumentResponsibles = computed(() => document.value?.responsibles ?? [])
const currentDocumentOrganizations = computed(() => document.value?.organizations ?? [])

function areIdSetsEqual (a: { id: number }[], b: { id: number }[]): boolean {
  if (a.length !== b.length) return false
  const bIds = new Set(b.map((item) => item.id))
  return a.every((item) => bIds.has(item.id))
}

const isResponsibleChanged = computed(() => {
  return !areIdSetsEqual(currentDocumentResponsibles.value, updatePayload.value.responsibles ?? [])
})

const isOrganizationChanged = computed(() => {
  return !areIdSetsEqual(currentDocumentOrganizations.value, updatePayload.value.organizations ?? [])
})

const isLimitDateChanged = computed(() => {
  if (!updatePayload.value.limit_date) return false
  const docLimitDate = document.value?.limit_date?.slice(0, 10)
  return updatePayload.value.limit_date !== docLimitDate
})

const shouldTransfer = computed(() => {
  return (isResponsibleChanged.value || isOrganizationChanged.value) &&
    !!updatePayload.value.responsibles?.length &&
    !!updatePayload.value.organizations?.length
})

const hasIncompleteTransfer = computed(() => {
  const hasOrganizations = !!updatePayload.value.organizations?.length
  const hasResponsibles = !!updatePayload.value.responsibles?.length
  return hasOrganizations !== hasResponsibles
})

const hasChanges = computed(() => {
  if (hasIncompleteTransfer.value) return false
  const hasInteractionChange = !isPayloadContentEmpty.value || !!updatePayload.value.files?.length
  return hasInteractionChange || isLimitDateChanged.value || shouldTransfer.value
})

function toggleUpdateOrganization (organization: OrganizationModel, checked: boolean): void {
  const current = updatePayload.value.organizations ?? []
  if (checked) {
    if (!current.some((o) => o.id === organization.id)) {
      updatePayload.value.organizations = [...current, organization]
    }
  } else {
    updatePayload.value.organizations = current.filter((o) => o.id !== organization.id)
    updatePayload.value.responsibles = (updatePayload.value.responsibles ?? []).filter((r) => r.organization_id !== organization.id)
  }
}

function toggleUpdateResponsible (responsible: UserModel, checked: boolean): void {
  const current = updatePayload.value.responsibles ?? []
  if (checked) {
    if (!current.some((r) => r.id === responsible.id)) {
      updatePayload.value.responsibles = [...current, responsible]
    }
  } else {
    updatePayload.value.responsibles = current.filter((r) => r.id !== responsible.id)
  }
}

function resetUpdatePayload (): void {
  if (!document.value) return
  updatePayload.value = {
    files: [],
    responsibles: [],
    organizations: []
  }
}

function getDocument (): void {
  axios.get(`api/documents/${props.id}`)
    .then((res: AxiosResponse<DocumentModel>) => {
      document.value = res.data
      resetUpdatePayload()
      if (res.data.newly_created_protocol) {
        isProtocolModalOpen.value = true
      }
    })
}

function getOrganizations (): void {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

function getUsers (): void {
  axios.get('/api/users')
    .then((res) => {
      users.value = res.data
    })
}

function updateDocument (status?: DocumentStatusEnum): void {
  isUpdatingDocument.value = true

  if (status) {
    const payload: Record<string, unknown> = { status: status, limit_date: updatePayload.value.limit_date }
    if (status === DocumentStatusEnum.COMPLETED && !isConclusionNoteEmpty.value) {
      payload.content = conclusionNote.value
    }
    axios.patch(`/api/documents/${document.value!.id}`, payload)
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        document.value = res.data.document
        if (status === DocumentStatusEnum.COMPLETED) {
          conclusionNote.value = ''
          showConclusionNoteError.value = false
        }
      }).finally(() => {
        isConfirmCompleteDocumentModal.value = false
        isUpdatingDocument.value = false
        toast.success(`Documento ${status == DocumentStatusEnum.UNDER_REVIEW ? 'reaberto' : 'finalizado'}`)
      })
  } else {
    const willTransfer = shouldTransfer.value
    const payload: Record<string, unknown> = { ...updatePayload.value }
    delete payload.responsibles
    delete payload.organizations
    if (willTransfer) {
      payload.responsible_ids = updatePayload.value.responsibles!.map((r) => r.id)
      payload.organization_ids = updatePayload.value.organizations!.map((o) => o.id)
    }
    if (isPayloadContentEmpty.value) {
      delete payload.content
    }
    if (!isLimitDateChanged.value) {
      delete payload.limit_date
    }
    axios.patch(`/api/documents/${document.value!.id}`, payload)
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        document.value = res.data.document
        resetUpdatePayload()
      }).finally(() => {
        isTransferDocumentModalOpen.value = false
        isUpdatingDocument.value = false
        toast.success(willTransfer ? 'Documento transferido' : 'Nova interação adicionada')
      })
  }
}

/* AI COMPLIANCE REVIEW */
const isReviewingCompliance = ref<boolean>(false)
const complianceResult = ref<{ ok: boolean, issues: string[] }>()

function reviewCompliance (): void {
  if (!updatePayload.value.content || isReviewingCompliance.value) return

  isReviewingCompliance.value = true

  const body = new FormData()
  body.append('content', updatePayload.value.content)
  if (document.value?.type) body.append('type', document.value.type as string)

  axios.post('/api/documents/ai-review-compliance', body)
    .then((res) => {
      complianceResult.value = res.data
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível revisar o documento com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isReviewingCompliance.value = false
      getAiUsage()
    })
}
/* AI COMPLIANCE REVIEW */

/* AI SUMMARIZATION */
const isSummarizingDocument = ref<boolean>(false)
const documentSummary = ref<string>('')

function summarizeDocument (): void {
  if (!document.value || isSummarizingDocument.value) return

  isSummarizingDocument.value = true

  const content = document.value.interactions.map((interaction) => interaction.content).join('\n')
  const body = new FormData()
  body.append('content', content)

  axios.post('/api/ai/summarize-content', body)
    .then((res) => {
      documentSummary.value = res.data.summary
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o resumo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSummarizingDocument.value = false
      getAiUsage()
    })
}
/* AI SUMMARIZATION */

/* AI REPLY SUGGESTION */
const isAiReplyPanelOpen = ref<boolean>(false)
const aiReplyPrompt = ref<string>('')
const isSuggestingAiReply = ref<boolean>(false)
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()

function getAiUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function suggestAiReply (): void {
  if (!document.value || isSuggestingAiReply.value) return

  isSuggestingAiReply.value = true

  const payload = new FormData()
  if (aiReplyPrompt.value.trim()) payload.append('prompt', aiReplyPrompt.value.trim())

  axios.post(`/api/documents/${document.value.id}/ai-suggest-reply`, payload)
    .then((res) => {
      updatePayload.value.content = res.data.content
      aiReplyPrompt.value = ''
      isAiReplyPanelOpen.value = false
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar a sugestão de resposta com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSuggestingAiReply.value = false
      getAiUsage()
    })
}
/* AI REPLY SUGGESTION */

async function visualizeFile (file: DocumentFileModel) {
  isFileVisualizerOpen.value = true
  fileVisualizerSrc.value = ''

  try {
    const response = await axios.get(`/api/documents/get-file-content/${file.id}`, { responseType: 'blob' })
    fileVisualizerSrc.value = URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

function downloadFile (event: Event, file: DocumentFileModel): void {
  event.preventDefault()
  axios.get(`/api/documents/get-file-content/${file.id}`, { responseType: 'blob' })
    .then(response => {
      const url = URL.createObjectURL(new Blob([response.data]))

      const link = window.document.createElement('a')
      link.href = url
      link.setAttribute('download', file.name)
      link.style.display = 'none'
      window.document.body.appendChild(link)
      link.click()
      window.document.body.removeChild(link)
    })
    .catch(error => {
      console.error('Erro ao buscar o documento:', error)
    })
}

function printHistory (): void {
  window.print()
}

function printProtocolFile (protocol?: ProtocolModel): void {
  const targetProtocol = protocol && protocol.id ? protocol : (document.value?.current_protocol || document.value?.newly_created_protocol)
  if (!targetProtocol || !document.value) return

  const pad = String(targetProtocol.number).padStart(3, '0')
  const acronym = targetProtocol.organization?.acronym || ''
  const numberStr = acronym ? `${pad} - ${acronym}` : pad
  const dateStr = formatBrazilDate(targetProtocol.created_at)
  const timeStr = formatBrazilTime(targetProtocol.created_at)
  const userStr = `${targetProtocol.creator?.name || ''} ${targetProtocol.creator?.last_name || ''}`

  const printWindow = window.open('', '', 'height=600,width=800')
  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Protocolo Digital</title>
          <style>
            body { font-family: sans-serif; display: flex; justify-content: center; padding: 40px; }
            .protocol-wrapper { width: 400px; border: 1px solid #ccc; padding: 30px; border-radius: 10px; }
            .row { display: flex; justify-content: space-between; margin-bottom: 10px; }
            .col { display: flex; flex-direction: column; }
            .label { font-size: 10px; color: #666; text-transform: uppercase; margin-bottom: 4px; }
            .value { font-size: 14px; color: #000; line-height: 1.4; }
            .value strong { font-weight: 700; font-size: 15px; }
            .divider { border-top: 1.5px dashed #000; margin: 15px 0; }
            .protocol-number { font-size: 32px; font-weight: bold; }
            .text-center { text-align: center; }
            h1 { margin: 0 0 20px 0; text-align: center; font-size: 26px; font-weight: 800; }
            .footer-alert { background: #E8F0EA; padding: 20px; text-align: center; font-size: 11px; font-weight: bold; margin-top: 20px; border-radius: 8px; }
          </style>
        </head>
        <body>
          <div class="protocol-wrapper">
            <h1>Protocolo digital</h1>
            <div class="row">
              <div class="col">
                <span class="label">REFERENTE</span>
                <span class="value">Documento<br><strong>${document.value.number}</strong></span>
              </div>
              <div class="col">
                <span class="label">&nbsp;</span>
                <span class="value">Ofício/portaria<br><strong>${document.value.physical_document_number || '-'}</strong></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row">
              <div class="col">
                <span class="label">VISUALIZADO EM</span>
                <span class="value">Data<br><strong>${dateStr}</strong></span>
              </div>
              <div class="col">
                <span class="label">&nbsp;</span>
                <span class="value">Horas<br><strong>${timeStr}</strong></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row" style="flex-direction: column;">
              <span class="label">USUÁRIO QUE VISUALIZOU</span>
              <span class="value"><strong>${userStr}</strong></span>
            </div>
            <div class="divider"></div>
            <div class="row" style="flex-direction: column;">
              <span class="label">NÚMERO DO PROTOCOLO GERADO</span>
              <span class="value protocol-number"><strong>${numberStr}</strong></span>
            </div>
            <div class="footer-alert">
              O SETOR DE ORIGEM FOI NOTIFICADO QUE VOCÊ JÁ VISUALIZOU<br>ESSE DOCUMENTO E RECEBEU O PROTOCOLO GERADO.
            </div>
          </div>
        </body>
      </html>
    `)
    printWindow.document.close()
    printWindow.focus()
    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 250)
  }
}

function downloadProtocolFile (protocol?: ProtocolModel): void {
  printProtocolFile(protocol) // Default to print since saving as PDF typically uses print to PDF
}

function printAllProtocols (): void {
  if (!document.value || !document.value.protocols?.length) return

  const docNumber = document.value.number
  const physicalDoc = document.value.physical_document_number || '-'
  
  let rowsHtml = ''
  document.value.protocols.forEach(protocol => {
    const pad = String(protocol.number).padStart(3, '0')
    const acronym = protocol.organization?.acronym || ''
    const numberStr = acronym ? `${pad} - ${acronym}` : pad
    const dateStr = formatBrazilDate(protocol.created_at)
    const timeStr = formatBrazilTime(protocol.created_at)
    const userStr = `${protocol.creator?.name || ''} ${protocol.creator?.last_name || ''}`
    const orgStr = `${protocol.organization?.name || ''} (${acronym})`
    
    rowsHtml += `
      <tr>
        <td><strong>${numberStr}</strong></td>
        <td>${orgStr}</td>
        <td>${userStr}</td>
        <td>${dateStr} às ${timeStr}</td>
      </tr>
    `
  })

  const printWindow = window.open('', '', 'height=600,width=800')
  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Relatório de Protocolos - Documento ${docNumber}</title>
          <style>
            body { font-family: sans-serif; padding: 40px; color: #000; }
            .header { text-align: center; margin-bottom: 30px; }
            h1 { margin: 0 0 10px 0; font-size: 24px; }
            .doc-info { font-size: 14px; color: #555; }
            .doc-info strong { color: #000; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
            th { background-color: #f5f5f5; font-weight: bold; text-transform: uppercase; font-size: 12px; }
            td strong { color: #1A5D2A; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Relatório de Protocolos Gerados</h1>
            <div class="doc-info">
              Documento: <strong>${docNumber}</strong> &nbsp;|&nbsp; Ofício/Portaria: <strong>${physicalDoc}</strong>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Protocolo</th>
                <th>Órgão/Secretaria</th>
                <th>Visualizado por</th>
                <th>Data e Hora</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </body>
      </html>
    `)
    printWindow.document.close()
    printWindow.focus()
    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 250)
  }
}

onMounted(() => {
  getDocument()
  getOrganizations()
  getUsers()
  getAiUsage()
})

watch([organizations, users], () => {
  if (!document.value) return

  if (organizations.value && updatePayload.value.organizations?.length) {
    updatePayload.value.organizations = updatePayload.value.organizations.map((org) => {
      return organizations.value?.find((o) => o.id === org.id) ?? org
    })
  }

  if (users.value && updatePayload.value.responsibles?.length) {
    updatePayload.value.responsibles = updatePayload.value.responsibles.map((responsible) => {
      return users.value?.find((u) => u.id === responsible.id) ?? responsible
    })
  }
})

/* Alert modal variables. */
const isConfirmCompleteDocumentModal = ref<boolean>(false)
const isTransferDocumentModalOpen = ref<boolean>(false)
const isProtocolModalOpen = ref<boolean>(false)
const isProtocolsListModalOpen = ref<boolean>(false)
const isConclusionNoteModalOpen = ref<boolean>(false)
const conclusionNote = ref<string>('')
const conclusionNoteEditorKey = ref<number>(0)
const showConclusionNoteError = ref<boolean>(false)

const isConclusionNoteEmpty = computed(() => {
  const content = conclusionNote.value ?? ''
  const strippedContent = content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim()
  return strippedContent === ''
})

function openConclusionNoteModal (): void {
  showConclusionNoteError.value = false
  conclusionNoteEditorKey.value++
  isConclusionNoteModalOpen.value = true
}

function closeConclusionNoteModal (open: boolean): void {
  if (open) return
  isConclusionNoteModalOpen.value = false
  showConclusionNoteError.value = false
  conclusionNote.value = ''
}

function confirmConclusionNote (): void {
  if (isConclusionNoteEmpty.value) {
    showConclusionNoteError.value = true
    return
  }
  isConclusionNoteModalOpen.value = false
  isConfirmCompleteDocumentModal.value = true
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day}/${mouth}/${year}`
}

const BRAZIL_TIMEZONE = 'America/Sao_Paulo'

const formatBrazilDate = (isoDate: string): string => {
  return new Date(isoDate).toLocaleDateString('pt-BR', { timeZone: BRAZIL_TIMEZONE })
}

const formatBrazilTime = (isoDate: string): string => {
  const time = new Date(isoDate).toLocaleTimeString('pt-BR', { timeZone: BRAZIL_TIMEZONE, hour: '2-digit', minute: '2-digit' })
  return time.replace(':', 'h ') + 'min'
}
</script>

<style lang="scss">
  .modal.conclusion-note {
    .modal__content {
      padding: 0 !important;
      border-radius: 28px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
      max-height: 90vh;
      height: fit-content !important;
    }
    .close-modal {
      display: flex !important;
      top: 28px;
      right: 28px;
      z-index: 2;
    }
    .conclusion-note-modal {
      display: flex;
      flex-direction: column;
      background: #FFF;
      header {
        padding: 32px 32px 0;
        h1 {
          color: #090909;
          font-family: 'Nunito', sans-serif;
          font-size: 24px;
          font-weight: 800;
          line-height: normal;
          margin: 0;
          text-align: start;
          letter-spacing: -0.3px;
        }
      }
      .body {
        padding: 24px 32px 0;
        display: flex;
        flex-direction: column;
        .field-label {
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-weight: 700;
          line-height: normal;
          margin: 0 0 12px 0;
          text-align: start;
          strong {
            color: #6F6F6F;
            font-size: 14px;
            font-weight: 400;
            margin-left: 4px;
          }
        }
        .editor-wrapper {
          width: 100%;
          .text-editor {
            margin: 0;
            border-radius: 20px;
            border: 2px solid $fluxoo-primary-color;
            transition: border-color .2s;
            &::before,
            &::after {
              content: unset !important;
            }
            &__menu-bar {
              padding: 1rem 1.5rem 0.75rem;
            }
            &--input {
              max-height: 280px;
              overflow-y: auto;
              .ProseMirror {
                min-height: 220px;
                padding: 0 1.5rem 1rem;
                box-sizing: border-box;
                outline: none;
              }
              &::-webkit-scrollbar {
                width: 6px;
              }
              &::-webkit-scrollbar-thumb {
                background: #D3D3D3;
                border-radius: 3px;
              }
            }
          }
          &--error {
            .text-editor {
              border-color: #C70E0E;
            }
          }
        }
        .error-text {
          color: #C70E0E;
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 500;
          margin: 8px 0 0 0;
          text-align: start;
        }
      }
      nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 16px;
        padding: 28px 32px 32px;
        margin-top: 4px;
        button {
          border: none;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
          &.submit {
            flex: 1;
            height: 60px;
            border-radius: 30px;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            line-height: normal;
            transition: background .2s, opacity .2s;
            &:hover:not(:disabled) {
              background: $fluxoo-primary-color-hover;
            }
            &:disabled {
              background: #B7E1D3;
              cursor: not-allowed;
            }
          }
          &.cancel {
            min-width: 100px;
            height: 60px;
            color: #737373;
            font-size: 16px;
            font-weight: 600;
            background: transparent;
            transition: color .2s;
            &:hover {
              color: $fluxoo-primary-color;
            }
          }
        }
      }
    }
  }

  @media(max-width: 690px) {
    .modal.conclusion-note {
      padding: 0 15px;
      .modal__content {
        border-radius: 20px;
      }
      .conclusion-note-modal {
        header {
          padding: 28px 20px 0;
          h1 {
            font-size: 20px;
            padding-right: 32px;
          }
        }
        .body {
          padding: 20px 20px 0;
        }
        nav {
          padding: 20px 20px 24px;
          flex-direction: column-reverse;
          row-gap: 8px;
          column-gap: 0;
          .submit, .cancel {
            width: 100%;
          }
        }
      }
    }
  }

  .digital-protocol {
    font-family: 'Inter', sans-serif;
    * {
      font-family: 'Inter', sans-serif;
    }
    .modal-content {
      padding: 0 !important;
      border-radius: 24px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
    }
    .protocol-content {
      padding: 35px 40px 30px 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #FFF;
      flex: 1;
      
      .icon-fingerprint {
        margin-bottom: 12px;
      }
      
      h1 {
        font-size: 28px !important;
        font-weight: 800 !important;
        color: #090909 !important;
        margin: 0 0 20px 0 !important;
        letter-spacing: -0.5px;
      }
      
      .info-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        text-align: left;
        
        .col {
          display: flex;
          flex-direction: column;
          flex: 1;
          
          &:last-child {
            padding-left: 20px;
          }
        }
        
        &.full {
          flex-direction: column;
        }
        
        .label {
          font-size: 10px;
          color: #7A7A7A;
          text-transform: uppercase;
          margin-bottom: 4px;
          letter-spacing: 0.5px;
          font-weight: 500;
        }
        
        .value {
          font-size: 14px;
          color: #555;
          line-height: 1.4;
          
          strong {
            font-weight: 700;
            font-size: 15px;
            color: #090909;
            display: block;
            margin-top: 2px;
          }
        }
      }
      
      .protocol-number {
        margin-top: 5px;
        .value {
          margin-top: 5px;
          strong {
            font-size: 46px !important;
            font-weight: 800 !important;
            color: #090909 !important;
            line-height: 1;
            letter-spacing: -1px;
          }
        }
      }
      
      .divider {
        width: 100%;
        height: 1px;
        border-top: 2px dashed #090909;
        margin: 14px 0;
      }
      
      .actions {
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 30px;
        gap: 15px;
        
        button {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          height: 46px;
          border-radius: 23px;
          border: 1px solid #E0E0E0;
          background: #FFF;
          color: #090909;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0px 2px 6px rgba(0,0,0,0.05);
          
          &:hover {
            background: #F8F8F8;
          }
          
          svg {
            width: 18px;
            height: 18px;
            stroke: #090909;
          }
        }
      }
    }
    
    .footer-alert {
      background: #E8F0EA;
      padding: 24px 30px;
      text-align: center;
      font-size: 11px;
      font-weight: 700;
      color: #090909;
      line-height: 1.5;
    }
  }

  .protocols-list {
    font-family: 'Inter', sans-serif;
    * {
      font-family: 'Inter', sans-serif;
    }
    .modal-content {
      padding: 0 !important;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
      max-height: 85vh;
      height: fit-content !important;
    }
    
    .protocols-list-content {
      padding: 35px 40px;
      display: flex;
      flex-direction: column;
      background: #FFF;
      overflow-y: auto;
      
      h2 {
        font-size: 24px !important;
        font-weight: 800 !important;
        color: #090909 !important;
        margin: 0 0 8px 0 !important;
        letter-spacing: -0.5px;
      }
      
      .modal-header-info {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
        
        .header-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          .btn-print-all {
            display: flex;
            align-items: center;
            gap: 8px;
            background: #F4F4F4;
            border: 1px solid #E0E0E0;
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 600;
            color: #333;
            cursor: pointer;
            transition: all 0.2s;
            
            &:hover {
              background: #EBEBEB;
              color: #000;
            }
          }
        }
        
        .doc-reference {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 6px;
          background: #F8F8F8;
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #EBEBEB;
          width: fit-content;
          
          .ref-label {
            font-size: 10px;
            font-weight: 700;
            color: #666;
            letter-spacing: 0.5px;
          }
          
          .ref-value {
            font-size: 13px;
            color: #333;
            strong { color: #000; }
          }
        }
      }
      
      .subtitle {
        font-size: 14px;
        color: #666;
        margin-bottom: 25px;
        line-height: 1.5;
      }
      
      .protocols-grid {
        display: flex;
        flex-direction: column;
        gap: 15px;
      }
      
      .protocol-card {
        border: 1px solid #EBEBEB;
        border-radius: 12px;
        padding: 20px;
        transition: all 0.2s;
        
        &:hover {
          border-color: #D0D0D0;
          box-shadow: 0px 4px 12px rgba(0,0,0,0.03);
        }
        
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          padding-bottom: 15px;
          border-bottom: 1px dashed #E0E0E0;
          
          .org-name {
            font-weight: 700;
            font-size: 15px;
            color: #090909;
          }
          
          .header-right {
            display: flex;
            align-items: center;
            gap: 12px;
            
            .protocol-badge {
              background: #E8F0EA;
              color: #1A5D2A;
              padding: 6px 12px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: 700;
              letter-spacing: 0.5px;
            }
            
            .card-actions {
              display: flex;
              gap: 6px;
              
              .btn-action {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                border: 1px solid #E0E0E0;
                background: #FFF;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s;
                color: #555;
                
                &:hover {
                  background: #F0F0F0;
                  color: #000;
                  border-color: #D0D0D0;
                }
              }
            }
          }
        }
        
        .card-body {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          
          .info-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
            
            .info-label {
              font-size: 11px;
              text-transform: uppercase;
              color: #888;
              font-weight: 600;
              letter-spacing: 0.5px;
            }
            
            .info-value {
              font-size: 14px;
              color: #333;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .view-document{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 32px 0 0 0;
    box-sizing: border-box;
    .infos{
      width: 100%;
      margin: 0 0 5px 0;
      display: flex;
      column-gap: 20px;
      p{
        display: flex;
        flex-wrap: wrap;
        column-gap: 3px;
      }
      .interactions{
        width: 100%;
        max-width: 692px;
        display: flex;
        flex-direction: column;
        .document{
          width: 100%;
          display: flex;
          flex-direction: column;
          border-radius: 24px;
          border: 1px solid #D3D3D3;
          position: relative;
          margin: 36px 0 0 0;
          .interaction-creator {
            margin: 0;
            display: inline-flex;
            position: absolute;
            top: -.63rem;
            left: 1.65rem;
            padding: 0.3125rem 0.375rem;
            border-radius: 0.5rem;
            background: var(--cinza-medio, #D3D3D3);
            color: var(--preto, #090909);
            font-family: Inter;
            font-size: 0.75rem;
            font-weight: 700;
          }
          &:nth-child(4){
            margin: 0;
            &::before{
              display: none;
            }
          }
          &::before{
            content: '';
            width: 2px;
            height: 36px;
            position: absolute;
            bottom: calc(100% + 1px);
            margin: 0 auto;
            background: #D3D3D3;
            position:absolute;
            left:50%;
            transform: translateX(-50%)
          }
          &__item{
            margin: 0 2rem;
            margin: 1rem;
            h1,h2,h3,h4,h5,h6{
              word-wrap: break-word !important;
              font-family: unset !important;
              font-weight: unset !important;
              color: unset !important;
              margin: unset !important
            }
            strong{
              font-size:unset !important;
              font-weight: bold !important;
            }
            h1 {
              font-size: 2em !important;
            }
            h2 {
              font-size: 1.5em !important;
            }
            h3 {
              font-size: 1.17em !important;
            }
            h4 {
              font-size: 1em !important;
            }
            h5 {
              font-size: 0.83em !important;
            }
            h6 {
              font-size: 0.67em !important;
            }
          }
          &__attachments{
            display: flex;
            flex-direction: column;
            padding: 17px 22px 26px;
            box-sizing: border-box;
            border-radius: 0px 0px 23px 23px;
            background: #F3F3F3;
            h1{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
              margin: 0 0 8px 0;
            }
            div{
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 0 0 10px 0;
              p{
                max-width: 80%;
                color: #737373;
                font-family: 'Inter', sans-serif;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-decoration-line: underline;
                margin: 0;
                text-align: start;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
              }
              button{
                width: 20px;
                min-width: 20px;
                height: 20px;
                min-height: 20px;
                figure{
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0;
                  svg{
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                    min-height: 20px;
                    stroke: #292F31;
                    transition: stroke .2s;
                  }
                }
                &::before{
                  content: 'Visualizar';
                  width: 85px;
                }
                &:hover{
                  figure{
                    svg{
                      stroke: $fluxoo-primary-color;
                    }
                  }
                }
              }
              a{
                button{
                  &::before{
                    content: 'Baixar';
                    width: 62px;
                  }
                }
              }
              &:last-child{
                margin: 0;
              }
              div{
                column-gap: 15px;
              }
            }
          }
        }
        .stats{
          display: flex;
          align-items: center;
          column-gap: 16px;
          margin: 0 0 24px 0;
          .tag{
            height: 40px;
            padding: 0 16px;
            border-radius: 30px;
            background: #F5F5F5;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            &.under_review{
              background: #D5CEE3;
              color: #4F1AC0;
            }
            &.completed{
              background: #CDEFE6;
              color: #079F72;
            }
            &.overdue{
              background: #FFD7D7;
              color: #C70E0E;
            }
            &.extended{
              background: #FFF8D3;
              color: #C09809;
            }
            &.pending{
              background: #FDDCC5;
              color: #E87308;
            }
            &.exceptions{
              background: #C8DEFF;
              color: #0F2494;
            }
          }
        }
        h1{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: start;
          margin: 28px 0 0 0;
          strong{
            font-size: 14px;
            font-weight: 400;
          }
        }
        h2{
          color: #6F6F6F;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0 0 13px 0;
          text-align: start;
          &.subtitle{
            color: #6F6F6F;
            font-family: 'Nunito', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-align: start;
            margin: 5px 0 40px 0;
          }
        }
        .text-editor{
          border-radius: 20px;
          border: 2px solid $fluxoo-primary-color;
          position: relative;
          margin: 36px 0 0 0;
          &__menu-bar{
            padding: calc(1rem + 10px) 2rem 1rem;
          }
          &::after{
            content: 'Nova interação';
            width: 105px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFF;
            font-family: 'Inter', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            border-radius: 8px;
            background: $fluxoo-primary-color;
            position: absolute;
            top: -14px;
            left: 27px;
          }
          &::before{
            content: '';
            width: 2px;
            height: 36px;
            position: absolute;
            bottom: calc(100% + 2px);
            margin: 0 auto;
            background: $fluxoo-primary-color;
            position:absolute;
            left:50%;
            transform: translateX(-50%)
          }
        }
        .date-picker-label{
          position: relative;
          display: flex;
          align-items: center;
          input[type="text"]{
            width: 100%;
            height: 55px;
            border-radius: 14px;
            border: 1px solid #D3D3D3;
            color: $fluxoo-primary-color;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            padding: 15px 20px;
            box-sizing: border-box;
            transition: border-color .2s, color .2s, background .2s;
            &:focus{
              outline: none;
            }
            &::placeholder{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              transition: color .2s;
            }
          }
          svg{
            width: 24px;
            min-width: 24px;
            height: 24px;
            min-height: 24px;
            stroke: #090909;
            position: absolute;
            right: 22px;
          }
        }
        .actions-doc{
          width: 100%;
          max-width: 1200px;
          position: sticky;
          bottom: 5px;
          margin: 28px 0 0 1px;
          &.reopen{
            display: none;
          }
          nav{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 32px;
            border-radius: 16px;
            background: #FFF;
            box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
            box-sizing: border-box;
            column-gap: 20px;
            button{
              column-gap: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: none;
              cursor: pointer;
              width: 100%;
              max-width: 464px;
              height: 60px;
              border-radius: 30px;
              background: $fluxoo-primary-color;
              color: #FFF;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
              transition: background .2s;
              svg{
                stroke: #FFF;
              }
              &:hover{
                background: $fluxoo-primary-color-hover;
              }
            }
            input{
              border: none;
              cursor: pointer;
              &:first-child{
                width: 100%;
                max-width: 464px;
                height: 60px;
                border-radius: 30px;
                background: $fluxoo-primary-color;
                color: #FFF;
                text-align: center;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                transition: background .2s;
                &:hover{
                  background: $fluxoo-primary-color-hover;
                }
              }
              &:last-child{
                color: #737373;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                background: unset;
                transition: color .2s;
                &:hover{
                  color: $fluxoo-primary-color;
                }
              }
            }
          }
        }
      }
      .historics{
        width: 100%;
        max-width: 488px;
        display: flex;
        flex-direction: column;
        align-items: start;
        row-gap: 10px;
        .actions{
          display: flex;
          column-gap: 16px;
          margin: 0 0 47px 0;
          button{
            height: 40px;
            display: flex;
            align-items: center;
            border-radius: 50px;
            background: #F5F5F5;
            padding: 0 20px;
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            column-gap: 10px;
            transition: background .2s, color .2s;
            cursor: pointer;
            svg{
              stroke: #090909;
              fill: #090909;
              transition: stroke .2s, fill .2s;
            }
            &:hover{
              background: $fluxoo-primary-color;
              color: #FFF;
              svg{
                stroke: #FFF;
                fill: #FFF;
              }
            }
          }
        }
        h1{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin: 0;
        }
        .historic-title-actions {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 0 10px 0;
          .print-btn-icon {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            background: #F5F5F5;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background .2s;
            color: #090909;
            figure {
              margin: 0;
              display: flex;
            }
            &::before {
              content: 'Imprimir histórico';
              width: 120px;
              right: 0;
            }
            &:hover {
              background: $fluxoo-primary-color;
              color: #FFF;
            }
          }
        }
        .print-header {
          display: none;
        }
        .info{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          border-radius: 24px;
          background: #F5F8F7;
          padding: 24px 20px;
          margin: 0 0 34px 0;
          box-sizing: border-box;
          p{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 800;
            line-height: normal;
            margin: 0 0 10px 0;
            text-align: start;
            strong{
              color: #6F6F6F;
              font-family: 'Inter', sans-serif;
              font-weight: 500;
            }
          }
          div{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            column-gap: 10px;
            row-gap: 10px;
            p{
              margin: 0;
              display: flex;
              column-gap: 3px;
            }
          }
        }
        .historic{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          margin: 0 0 34px 0;
          .item{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 24px 20px;
            border-radius: 24px;
            border: 1px solid #F1F1F1;
            position: relative;
            box-sizing: border-box;
            span{
              width: 25px;
              min-width: 25px;
              height: 25px;
              min-height: 25px;
              border-radius: 50%;
              background: #D3D3D3;
              display: flex;
              align-items: center;
              justify-content: center;
              color:#737373;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              position: absolute;
              top: 24px;
              right: 20px;
            }
            p{
              display: unset;
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 800;
              line-height: normal;
              margin: 0 0 10px 0;
              text-align: start;
              strong{
                color: #6F6F6F;
                font-family: 'Inter', sans-serif;
                font-weight: 500;
              }
              &:nth-child(2){
                max-width: calc(100% - 30px);
              }
            }
            div{
              width: 100%;
              display: flex;
              padding: 20px 15px;
              border-radius: 20px;
              background: #EFF5F4;
              box-sizing: border-box;
              margin: -2px 0 0 0;
              p{
                color: #084231;
                font-family: 'Inter', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin: 0;
                text-align: start;
                strong{
                  font-weight: 700;
                  color: #084231;
                }
              }
            }
          }
        }
        .document-notes{
          width: 100%;
          display: flex;
          flex-direction: column;

          &__header{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 0 12px 0;

            h1{
              margin: 0;
            }
          }

          &__badge{
            display: inline-flex;
            align-items: center;
            column-gap: 5px;
            background: #F5F8F7;
            border: 1px solid #D3EDD7;
            border-radius: 20px;
            padding: 4px 10px;
            color: #079F72;
            font-family: 'Inter', sans-serif;
            font-size: 11px;
            font-weight: 600;
            white-space: nowrap;

            svg{
              stroke: #079F72;
              flex-shrink: 0;
            }
          }

          &__list{
            display: flex;
            flex-direction: column;
            row-gap: 8px;
            margin: 0 0 34px 0;
          }

          &__item{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 18px 20px;
            border-radius: 20px;
            border: 1px solid #F1F1F1;
            background: #FAFAFA;
            box-sizing: border-box;
            transition: border-color .2s;

            &:hover{
              border-color: #D3EDD7;
            }
          }

          &__item-header{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            column-gap: 10px;
            margin: 0 0 4px 0;
          }

          &__title{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 700;
            margin: 0;
            text-align: start;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          &__date{
            color: #6F6F6F;
            font-family: 'Inter', sans-serif;
            font-size: 12px;
            font-weight: 400;
            white-space: nowrap;
          }

          &__description{
            color: #6F6F6F;
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-weight: 400;
            margin: 0;
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }

        .viewers{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: start;
          border-radius: 24px;
          border: 1px solid #F1F1F1;
          padding: 24px 20px;
          box-sizing: border-box;
          .viewer{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: start;
            padding: 0 0 22px 0;
            margin: 0 0 20px 0;
            border-bottom: 1px solid #F1F1F1;
            p{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 800;
              line-height: normal;
              margin: 0 0 10px 0;
              text-align: start;
              strong{
                color: #6F6F6F;
                font-family: 'Inter', sans-serif;
                font-weight: 500;
              }
              &:last-child{
                margin: 0;
              }
            }
            &:last-child{
              margin: 0;
              padding: 0;
              border: unset;
            }
          }
        }
      }
    }
    .modal{
      &.date-limit{
        .modal__content{
          padding: 15px 28px;
          box-sizing: border-box;
          overflow-y: auto;
          &::-webkit-scrollbar{
            width: 0;
          }
          button{
            display: flex;
            top: 26px;
            right: 28px;
          }
          .modal-date-title{
            padding: 0;
            display: flex;
            flex-direction: column;
            align-items: start;
            margin: 0 0 25px 0;
            h1{
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 32px;
              font-weight: 800;
              text-align: start;
              margin: 0;
            }
            h2{
              color: #6F6F6F;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 400;
              line-height: 2px;
              margin: 0;
            }
          }
          input[type='button']{
            width: 100%;
            min-height: 55px;
            border-radius: 30px;
            border: none;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 600;
            margin: 8px 0 0 0;
            transition: background .2s;
            cursor: pointer;
            &:disabled{
              background: #F1F1F1 !important;
              color: #6F6F6F !important;
              cursor: not-allowed !important;
            }
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
          }
        }
      }
    }
    .modal{
      &__content{
        margin: 15px 0 auto 0;
      }
      &.confirm-complete-document{
        &.picker{
          .modal__content{
            margin: 0;
            button{
              display: none;
            }
            div{
              align-items: start;
              padding: 19px 15px 24px;
              .close-modal{
                display: flex;
                width: 24px;
                min-width: 24px;
                height: 24px;
                min-height: 24px;
                position: absolute;
                top: 28px;
                right: 23px;
                cursor: pointer;
                figure{
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0;
                  svg{
                      width: 16px;
                      min-width: 16px;
                      height: 16px;
                      min-height: 16px;
                      fill: #090909;
                      transition: fill .2s;
                      &:hover{
                          fill: $fluxoo-primary-color;
                      }
                  }
                }
              }
              section{
                button{
                  display: flex;
                }
              }
            }
          }
        }
        .modal__content{
          button ~ div{
            overflow-y: auto;
            &::-webkit-scrollbar{
              width: 0;
            }
          }
          div{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 26px 15px 24px;
            box-sizing: border-box;
            h1{
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 28px;
              font-style: normal;
              font-weight: 900;
              line-height: normal;
              margin: 2px 0 7px 0;
              figure{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 1px 0 0 0;
                cursor: pointer;
                svg{
                  fill: #090909;
                  transition: fill .2s;
                  &:hover{
                    fill: $fluxoo-primary-color;
                  }
                }
              }
            }
            h2{
              color: #6F6F6F;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 15px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              margin: 0;
            }
            section{
              width: 100%;
              display: flex;
              align-items: center;
              flex-direction: row;
              justify-content: space-between;
              padding: 0;
              margin: auto 0 0 0;
              button{
                height: 30px;
                width: 80px;
                top: unset;
                color: #090909;
                font-family: 'Inter', sans-serif;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 18px;
                display: flex;
                justify-content: center;
                align-items: center;
                transition: color .2s;
                cursor: pointer;
                &:hover{
                  color: $fluxoo-primary-color;
                }
              }
              input{
                height: 60px;
                border-radius: 30px;
                background: #090909;
                color: #FFF;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                border: none;
                width: 173px;
                cursor: pointer;
              }
            }
            .dates{
              padding: 15px 0;
              min-height: 330px;
              margin: 0 auto 10px;
              .date-picker{
                max-width: 290px;
                padding: 0;
                .select-date{
                  display: flex !important;
                  flex-direction: row !important;
                  padding: 0;
                  .mySelect{
                    &.open{
                      div{
                        display: flex;
                      }
                    }
                    div{
                      height: unset;
                      display: none;
                      padding: 5px 10px 5px 0;
                    }
                  }
                }
                .select-day{
                  padding: 0;
                  .date{
                    display: grid;
                    padding: 0;
                  }
                }
              }
            }
          }
        }
        .close-modal{
          display: flex;
          top: 28px;
          right: 28px;
        }
      }
      &.transfer-document{
        padding: 15px;
        .modal__content{
          position: relative;
          padding: 32px 32px 0;
          box-sizing: border-box;
          overflow-y: auto;
          margin: 0;
          &::-webkit-scrollbar{
            width: 0;
          }
          .transfer{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: start;
            h1{
              &:first-child{
                color: #090909;
                font-family: 'Nunito', sans-serif;
                font-size: 28px;
                font-style: normal;
                font-weight: 800;
                line-height: normal;
                margin: 0;
              }
            }
            .option{
              .top{
                display: flex;
                flex-direction: row;
                align-items: center;
              }
            }
            .text-editor{
              border: 1px solid #D3D3D3;
              margin: 0;
              &__menu-bar{
                flex-direction: row;
                box-sizing: border-box;
              }
              &--input{
                div{
                  box-sizing: border-box;
                }
              }
              &::before{
                content: unset;
              }
              &::after{
                content: unset;
              }
            }
            .file-document{
              width: 100%;
              margin: 0 0 40px 0;
            }
          }
          nav{
            width: 100%;
            max-width: 1200px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 32px;
            border-radius: 16px;
            background: #FFF;
            box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.12);
            box-sizing: border-box;
            position: sticky;
            bottom: 5px;
            column-gap: 20px;
            margin: auto 0 0 1px;
            input{
              border: none;
              cursor: pointer;
              &:first-child{
                width: 100%;
                max-width: 464px;
                height: 60px;
                border-radius: 30px;
                background: $fluxoo-primary-color;
                color: #FFF;
                text-align: center;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                transition: background .2s;
                &:hover{
                  background: $fluxoo-primary-color-hover;
                }
              }
              &:last-child{
                color: #737373;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                background: unset;
                transition: color .2s;
                &:hover{
                  color: $fluxoo-primary-color;
                }
              }
            }
          }
        }
        .close-modal{
          display: flex;
          top: 41px;
          right: 32px;
        }
      }
    }
  }

  @media(max-width: 1000px){
    .view-document{
      .infos{
        margin: 0 0 120px 0;
        row-gap: 28px;
        flex-direction: column;
        position: relative;
        .interactions{
          max-width: unset;
          .stats{
            &.reopen{
              padding: 0 0 0 141px !important;
            }
            &.close{
              padding: 0 0 0 300px !important;
            }
            &.block{
              padding: 0;
            }
          }
          .actions-doc{
            position: fixed;
            box-sizing: border-box;
            bottom: 4px;
            left: 0;
            z-index: 1;
            padding: 0 15px 0 81px;
          }
        }
        .historics{
          max-width: unset;
          .actions{
            position: absolute;
            top: 0;
          }
        }
      }
    }
  }

  @media(max-width: 690px){
    .view-document{
      .infos{
        .interactions{
          .stats{
            margin: 0 0 12px 0;
            &.reopen{
              padding: 60px 0 0 0 !important;
            }
            &.close{
              padding: 60px 0 0 0 !important;
            }
            &.block{
              padding: 0;
            }
          }
        }
      }
    }
  }

  @media(max-width: 425px){
    #reopen{
      display: none;
    }
    .view-document{
      .infos{
        .interactions{
          .stats{
            margin: 0 0 12px 0;
            &.reopen{
              padding: 0 !important;
            }
          }
          .actions-doc{
            animation: enterToBottom ease 0.9s;
            width: 100vw;
            position: fixed;
            left: 0;
            bottom: 0;
            z-index: 4;
            padding: 0;
            &.reopen{
              display: flex;
            }
            nav{
              border-radius: 20px 20px 0px 0px;
              background: #FFF;
              box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
              padding: 15px;
            }
          }
        }
      }
      .modal {
        padding: 0 15px;
        &__content{
          border-radius: 28px;
          max-width: unset !important;
          max-height: unset !important;
          bottom: unset;
          left: unset;
          right: unset;
          top: 0;
          opacity: 0;
          transition: all 0.2s ease-out;
          &.closed {
              opacity: 0;
              transform: translateY(-110%) !important;
          }
          &.open {
              opacity: 1;
              transform: translateY(0) !important;
          }
        }
        &.transfer-document{
          padding: 0;
          .modal__content{
            border-radius: 0;
            padding: 0;
            display: flex;
            flex-direction: column;
            nav{
              animation: enterToBottom ease 0.9s;
              width: 100vw;
              position: sticky;
              bottom: 0;
              border-radius: 20px 20px 0px 0px;
              background: #FFF;
              box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
              padding: 15px;
              box-sizing: border-box;
              z-index: 3;
              margin: 0;
            }
            .close-modal{
              display: flex;
              top: 38px;
              right: 15px;
            }
            .transfer{
              padding: 32px 15px 0;
              box-sizing: border-box;
              h1{
                &:first-child{
                  font-size: 24px;
                }
              }
            }
          }
        }
        &.confirm-complete-document{
          &.picker{
            padding: 10px;
            .modal__content{
              div{
                padding: 19px 10px 24px;
                .dates{
                  padding: 15px 0;
                  .date-picker{
                    .select-day{
                      .date{
                        gap: 2px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media print {
    /* Oculta tudo por padrão */
    * {
      visibility: hidden;
      box-shadow: none !important;
    }

    /* Mostra apenas a seção de histórico */
    .historics, .historics * {
      visibility: visible;
    }

    .historics {
      position: absolute;
      left: 0;
      top: 0;
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
      display: block !important;
      background: white !important;
    }

    .print-header {
      display: block !important;
      margin-bottom: 30pt !important;
      border-bottom: 2pt solid #000 !important;
      padding-bottom: 10pt !important;
      h1 { font-size: 20pt !important; font-weight: bold !important; margin: 0 !important; color: #000 !important; }
      h2 { font-size: 14pt !important; margin: 5pt 0 !important; color: #333 !important; }
      h3 { font-size: 12pt !important; margin: 0 !important; color: #666 !important; }
    }

    .historic-title-actions h1 {
      display: none !important;
    }

    .info {
      border: 1px solid #ddd !important;
      padding: 10pt !important;
      margin-bottom: 15pt !important;
      border-radius: 24px !important;
    }

    .historic, .viewers {
      border: none !important;
      padding: 0 !important;
      margin-bottom: 15pt !important;
    }

    .item {
      break-inside: avoid !important;
      border: 1px solid #eee !important;
      margin-bottom: 10pt !important;
      page-break-inside: avoid !important;
    }

    .historic-title-actions h1, .print-btn-icon, .actions {
      display: none !important;
    }

    /* Remove cores de fundo para impressão limpa */
    .item div {
      background: #fafafa !important;
    }

    p, strong, span {
      color: #000 !important;
    }

    /* Ajuste para o número do índice */
    .historics .item span {
      position: absolute !important;
      right: 10pt !important;
      top: 10pt !important;
      background: #eee !important;
    }
  }
</style>
